import classNames from 'classnames';
import {forEach, sumBy} from 'lodash';
import map from 'lodash/map';
import moment from 'moment';
import numeral from 'numeral';
import React from 'react';
import {connect} from 'react-redux';
import swal from 'sweetalert2';
import {fetchStatsLeaguesByStatus} from '../../../../../actions/entities/statistics/leagues';
import earthFlag from '../../../../../assets/img/other/flag-earth.svg';
import {championshipsById} from '../../../../../components/ChampionshipSelector';
import SingleDatePickerWrapper from '../../../../../components/DatePicker/SingleDatePickerWrapper';
import Loader from '../../../../../components/Loader';
import {getLeagueStatusName} from '../../../../../helpers/league';
import {getIncrease} from '../../../../../helpers/stats';

class LeaguesByStatusWidget extends React.Component {
  constructor(props) {
    super(props);

    // We set the date to yesterday and we subtract 30 days
    const today = new Date();
    const end = moment(today.setDate(today.getDate())).format('YYYY-MM-DD');

    this.state = {end, lang: 'ALL'};
  }

  fetchStatsLeaguesByStatus() {
    const {end} = this.state;
    const {isFetching} = this.props;

    if (!isFetching) {
      this.props.dispatch(
        fetchStatsLeaguesByStatus(
          {
            endDate: end,
          },
          null,
          (type, error) =>
            swal({
              title: `Oops...`,
              type: 'error',
              html:
                `Something went wrong:<br/>"${type}"<br/>${error}<br/>` +
                `<pre><code>${JSON.stringify(
                  error,
                  undefined,
                  4,
                )}</code></pre>`,
            }),
        ),
      );
    }
  }

  toggleLang(value) {
    const {lang} = this.state;

    if (lang === value) {
      this.setState({lang: 'ALL'});
    } else {
      this.setState({lang: value});
    }
  }

  static renderRow(
    name,
    current,
    previous,
    totalCurrentMercato,
    totalPreviousMercato,
    totalCurrentDraft,
    totalPreviousDraft,
    id,
  ) {
    const currentPercentMercato =
      (current.total[1] / totalCurrentMercato) * 100;
    const currentPercentDraft = (current.total[2] / totalCurrentDraft) * 100;
    const infinityMercato = previous.total[1] === 0 && current.total[1] !== 0;
    const increaseMercato =
      getIncrease(current.total[1], previous.total[1]) || 0;
    const infinityDraft = previous.total[2] === 0 && current.total[2] !== 0;
    const increaseDraft = getIncrease(current.total[2], previous.total[2]) || 0;

    const title = getLeagueStatusName(name);

    return (
      <tr
        key={`${id}-${name}`}
        data-toggle="collapse"
        data-target={`.${id}-${name}`}>
        <td style={{width: '150px '}}>
          {title}
          <div className={`${id}-${name} collapse`}>
            {map(
              current,
              (value, index) =>
                index !== 'total' && (
                  <div key={index} className="text-right">
                    <b>{index}</b>
                    <br />
                    -<br />-
                  </div>
                ),
            )}
          </div>
        </td>
        <th className="text-center">
          {current.total[1] + current.total[2]}
          <div className={`${id}-${name} collapse`}>
            {map(
              current,
              (value, index) =>
                index !== 'total' && (
                  <div key={index} className="text-center">
                    {parseInt(value[1], 10) + parseInt(value[2], 10)}
                    <br />
                    {value[1]}
                    <br />
                    {value[2]}
                  </div>
                ),
            )}
          </div>
        </th>
        <td className="text-center">
          {numeral(currentPercentMercato).format('0')} % ||{' '}
          {numeral(currentPercentDraft).format('0')} %
        </td>
        <td className="text-center">
          {previous.total[1] + previous.total[2]}

          <div className={`${id}-${name} collapse`}>
            {map(
              previous,
              (value, index) =>
                index !== 'total' && (
                  <div key={index} className="text-center">
                    {parseInt(value[1], 10) + parseInt(value[2], 10)}
                    <br />
                    {value[1]}
                    <br />
                    {value[2]}
                  </div>
                ),
            )}
          </div>
        </td>
        <td className="text-center">
          {infinityMercato ? (
            <span>
              +<span style={{fontSize: '18px'}}>∞</span>
            </span>
          ) : (
            numeral(increaseMercato).format('+0')
          )}{' '}
          % ||{' '}
          {infinityDraft ? (
            <span>
              +<span style={{fontSize: '18px'}}>∞</span>
            </span>
          ) : (
            numeral(increaseDraft).format('+0')
          )}{' '}
          %
          <div className={`${id}-${name} collapse`}>
            {map(
              current,
              (value, index) =>
                index !== 'total' && (
                  <div key={index} className="text-center">
                    {numeral(
                      getIncrease(
                        value[1] + value[2],
                        previous[index][1] + previous[index][2],
                      ) || 0,
                    ).format('+0')}
                    %<br />
                    <br />
                    <br />
                  </div>
                ),
            )}
          </div>
        </td>
      </tr>
    );
  }

  static orderTable(table) {
    // No order for this widget
    return table;
  }

  renderTable(table, id) {
    if (!table) return false;

    const orderedTable = LeaguesByStatusWidget.orderTable(table);
    let totalCurrent = 0;
    let totalPrevious = 0;
    forEach(table, championships => {
      forEach(championships, value => {
        totalCurrent += value.current;
        totalPrevious += value.previous;
      });
    });

    return (
      <div className="mt-3 table-responsive">
        <table className="table table-striped">
          <thead>
            <tr className="bg-gray">
              <th>Ligue</th>
              <th className="text-center">Nombre</th>
              <th className="text-center">%</th>
              <th className="text-center">vs S-1</th>
              <th className="text-center">% S-1</th>
            </tr>
          </thead>
          <tbody>
            {map(orderedTable, (value, status) => {
              const title = getLeagueStatusName(status);
              const totalCurrentByMode = sumBy(Object.values(value), 'current');
              const totalPreviousByMode = sumBy(
                Object.values(value),
                'previous',
              );
              return (
                <tr
                  key={`${id}-${status}`}
                  data-toggle="collapse"
                  data-target={`.${id}-${status}`}>
                  <td style={{width: '150px '}}>
                    {title}
                    <div className={`${id}-${status} collapse`}>
                      {map(value, (_value, index) => (
                        <div key={index} className="text-right">
                          <b>{championshipsById[index].label}</b>
                        </div>
                      ))}
                    </div>
                  </td>
                  <td className="text-center">
                    <b>{totalCurrentByMode}</b>
                    <div className={`${id}-${status} collapse`}>
                      {map(value, (number, index) => (
                        <div key={index} className="text-center">
                          {number.current}
                        </div>
                      ))}
                    </div>
                  </td>
                  <td className="text-center">
                    {numeral((totalCurrentByMode / totalCurrent) * 100).format(
                      '0',
                    )}{' '}
                    %
                  </td>
                  <td className="text-center">
                    <b>{totalPreviousByMode}</b>
                    <div className={`${id}-${status} collapse`}>
                      {map(value, (number, index) => (
                        <div key={index} className="text-center">
                          {number.previous}
                        </div>
                      ))}
                    </div>
                  </td>
                  <td className="text-center">
                    {numeral(
                      (totalPreviousByMode / totalPrevious) * 100,
                    ).format('0')}{' '}
                    %
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }

  renderLeaguesByModeByStatus() {
    const {data, isFetching} = this.props;
    const {lang} = this.state;
    const table = data && data[lang];

    return (
      !isFetching &&
      table &&
      map(table, (statusTable, status) => {
        const id = `leaguesByModeByStatus-${status}`;
        return (
          <div key={id} id={id} className="mb-4">
            <h3 className="my-0 ml-3">{status.toUpperCase()}</h3>
            {this.renderTable(statusTable, id, status)}
          </div>
        );
      })
    );
  }

  render() {
    const {end, lang} = this.state;
    const {isFetching} = this.props;

    return (
      <div id="leagues-stats-widget">
        <div className="box">
          <div className="box-header with-border">
            <h3 className="box-title pull-left">
              <i className="fa fa-tags" /> Ligues par status
            </h3>
            <br />
            Dernier status des ligues le {this.state.end}, par mode, par nombre
            de joueur
          </div>
          <div className="box-body">
            <div className="text-center">
              <div className="inline lang">
                <button
                  className={classNames('btn btn-box-tool', {
                    selected: lang === 'FR',
                  })}
                  onClick={() => this.toggleLang('FR')}>
                  <span className="flag-icon flag-icon-fr" />
                </button>
                <button
                  className={classNames('btn btn-box-tool', {
                    selected: lang === 'GB',
                  })}
                  onClick={() => this.toggleLang('GB')}>
                  <span className="flag-icon flag-icon-gb" />
                </button>
                <button
                  className={classNames('btn btn-box-tool', {
                    selected: lang === 'ES',
                  })}
                  onClick={() => this.toggleLang('ES')}>
                  <span className="flag-icon flag-icon-es" />
                </button>
                <button
                  className={classNames('btn btn-box-tool', {
                    selected: lang === 'OTHER',
                  })}
                  onClick={() => this.toggleLang('OTHER')}>
                  <img
                    src={earthFlag}
                    alt="Drapeau de la terre"
                    className="flag-img-btn"
                  />
                </button>
              </div>
              <div className="inline data-range-picker">
                <SingleDatePickerWrapper
                  initialDate={moment(end)}
                  onDateChange={date => {
                    this.setState({
                      end: moment(date).format('YYYY-MM-DD'),
                    });
                  }}
                  isOutsideRange={() => false}
                />
                <button
                  className="ml-2 inline btn btn-default"
                  onClick={() => this.fetchStatsLeaguesByStatus()}>
                  <i className="fa fa-refresh" />
                </button>
              </div>
            </div>
          </div>
          {isFetching && <Loader />}
          {this.renderLeaguesByModeByStatus()}
        </div>
      </div>
    );
  }
}

export default connect(
  state => state.app.statistics.leaguesByStatus,
  dispatch => ({dispatch}),
)(LeaguesByStatusWidget);



// WEBPACK FOOTER //
// ./src/pages/Monitoring/Statistics/Widgets/LeaguesByStatus/index.js